// import React, { useEffect, useState } from "react";
// import { Controller } from "react-hook-form";
// import Autocomplete, { AutocompletePropsSizeOverrides } from "@mui/material/Autocomplete";
// import TextField from "@mui/material/TextField";
// import Chip from "@mui/material/Chip";
// import CircularProgress from "@mui/material/CircularProgress";
// import http from "../../commonFunctions/httpClient";
// import { OverridableStringUnion } from "@mui/types";
// import { SxProps } from "@mui/material";

// interface Option {
//   value: string | number;
//   label: string;
//   disabled?: boolean;
// }

// interface WSMultiAutoCompleteProps {
//   control: any;
//   name: string;
//   label: string;
//   options?: Option[];
//   defaultValue?: Option[];
//   multiple?: boolean;
//   disabled?: boolean;
//   freeSolo?: boolean;
//   required?: boolean;
//   setValue?:any;
//   rules:any;
//     controllSize?: OverridableStringUnion<'small' | 'medium', AutocompletePropsSizeOverrides>;
//   source?: {
//     url: string;
//     pageSize: number;
//     filter?: any[];
//     sort?: string[];
//   };
//   transFormData?: (data: any) => Option[];
// }

// const WSMultiAutoComplete: React.FC<WSMultiAutoCompleteProps> = ({
//   control,
//   name,
//   label,
//   options = [],
//   defaultValue = [],
//   multiple = true,
//   disabled = false,
//   freeSolo = false,
//   required = false,
//   source,
//   rules,
//   transFormData,
//   controllSize="small",
//   setValue
// }) => {
//   const [loading, setLoading] = useState<boolean>(!!source);
//   const [newOptions, setNewOptions] = useState<Option[]>(options);
//   useEffect(() => {
//     if (setValue && defaultValue?.length > 0 && newOptions.length > 0) {
//       const mappedValues = defaultValue.map((id) => 
//         newOptions.find((option:any) => option.value === id) || { value: id, label: id }
//       );
//       setValue(name, mappedValues);
//     }
//   }, [setValue, name, defaultValue, newOptions]);
  
//   useEffect(() => {
//     if (source) {
//       (async () => {
//         try {
//           const response:any = await http.post(source.url, {
//             page: 1,
//             pageSize: source.pageSize,
//             filter: source.filter,
//             sort: source.sort,
//           });
//           setNewOptions(transFormData ? transFormData(response.data) : response.data);
//         } catch (error) {
//           console.error("Error fetching options:", error);
//         } finally {
//           setLoading(false);
//         }
//       })();
//     }
//   }, []);
//   const commonFontSize: SxProps = {
//     fontSize: '0.75rem',
//     '& .MuiInputBase-input': {
//       fontSize: '0.75rem',
//     },
//     '& .MuiInputLabel-root': {
//       fontSize: '0.75rem',
//     },
//     '& .MuiAutocomplete-option': {
//       fontSize: '0.75rem',
//     },
//   };
//   return (
//     <Controller
//       name={name}
//       control={control}
//       defaultValue={defaultValue}
//       rules={rules}
//       render={({ field, fieldState }) => (
//         <Autocomplete
//           {...field}
//           multiple={multiple}
//           freeSolo={freeSolo}
//           size={controllSize}
        
//           options={newOptions}
//           getOptionLabel={(option) => (typeof option === "string" ? option : option.label)}
//           onChange={(_, value) => field.onChange(value)}
//           disabled={disabled || loading}
//           sx={commonFontSize}
//           renderTags={(value, getTagProps) =>
            
//             value.map((option, index) => (
//               <Chip sx={{fontSize:'0.75rem'}}
             
//                 label={typeof option === "string" ? option : option.label}
//                 {...getTagProps({ index })}
//               />
//             ))
//           }
//           renderInput={(params) => (
//             <TextField  
//               {...params}
//               label={label}
//               sx={{fontSize:'0.75rem'}}
//               variant="outlined"
//               error={!!fieldState.error}
//               helperText={fieldState.error?.message}
//               InputProps={{
//                 ...params.InputProps,
//                 endAdornment: (
//                   <>
//                     {loading && <CircularProgress color="inherit" size={20} />}
//                     {params.InputProps.endAdornment}
//                   </>
//                 ),
//               }}
//             />
//           )}
//         />
//       )}
//     />
//   );
// };

// export default WSMultiAutoComplete;

import React, { useEffect, useState } from "react";
import { Controller, Control, FieldValues, FieldPath } from "react-hook-form";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Chip from "@mui/material/Chip";
import CircularProgress from "@mui/material/CircularProgress";
import http from "../../commonFunctions/httpClient";
import { OverridableStringUnion } from "@mui/types";
import { SxProps } from "@mui/material";

interface Option {
  value: string | number;
  label: string;
  disabled?: boolean;
}

interface WSMultiAutoCompleteProps<TFieldValues extends FieldValues> {
  control: Control<TFieldValues>; // required
  name: FieldPath<TFieldValues>;
  label: string;
  options?: Option[];
  defaultValue?: Option[];
  multiple?: boolean;
  disabled?: boolean;
  freeSolo?: boolean;
  required?: boolean;
  setValue?: any;
  rules?: any;
  controllSize?: OverridableStringUnion<'small' | 'medium', {}>;
  source?: {
    url: string;
    pageSize: number;
    filter?: any[];
    sort?: string[];
  };
  transFormData?: (data: any) => Option[];
}

const WSMultiAutoComplete = <TFieldValues extends FieldValues>({
  control,
  name,
  label,
  options = [],
  defaultValue = [],
  multiple = true,
  disabled = false,
  freeSolo = false,
  rules,
  source,
  transFormData,
  controllSize = "small",
  setValue
}: WSMultiAutoCompleteProps<TFieldValues>) => {
  const [loading, setLoading] = useState<boolean>(!!source);
  const [newOptions, setNewOptions] = useState<Option[]>(options);

  // Set default value if provided
  useEffect(() => {
    if (setValue && defaultValue?.length && newOptions.length) {
      const mappedValues = defaultValue.map((id) =>
        newOptions.find((option) => option.value === id.value) || id
      );
      setValue(name, mappedValues);
    }
  }, [setValue, name, defaultValue, newOptions]);

  // Fetch options from API if source provided
  useEffect(() => {
    if (source) {
      (async () => {
        try {
          const response: any = await http.post(source.url, {
            page: 1,
            pageSize: source.pageSize,
            filter: source.filter,
            sort: source.sort,
          });
          setNewOptions(transFormData ? transFormData(response.data) : response.data);
        } catch (error) {
          console.error("Error fetching options:", error);
        } finally {
          setLoading(false);
        }
      })();
    }
  }, []);

  const commonFontSize: SxProps = {
    fontSize: '0.75rem',
    '& .MuiInputBase-input': { fontSize: '0.75rem' },
    '& .MuiInputLabel-root': { fontSize: '0.75rem' },
    '& .MuiAutocomplete-option': { fontSize: '0.75rem' },
  };

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue as any} // TypeScript workaround for multi-select
      rules={rules}
      render={({ field, fieldState }) => (
        <Autocomplete
          {...field}
          multiple={multiple}
          freeSolo={freeSolo}
          size={controllSize}
          options={newOptions}
          getOptionLabel={(option) =>
            typeof option === "string" ? option : option.label
          }
          onChange={(_, value) => field.onChange(value)}
          disabled={disabled || loading}
          sx={commonFontSize}
          renderTags={(value: (Option | string)[], getTagProps) =>
            value.map((option, index) => (
              <Chip
                sx={{ fontSize: '0.75rem' }}
                label={typeof option === "string" ? option : option.label}
                {...getTagProps({ index })}
              />
            ))
          }
          renderInput={(params) => (
            <TextField
              {...params}
              label={label}
              sx={{ fontSize: '0.75rem' }}
              variant="outlined"
              error={!!fieldState.error}
              helperText={fieldState.error?.message}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <>
                    {loading && <CircularProgress color="inherit" size={20} />}
                    {params.InputProps.endAdornment}
                  </>
                ),
              }}
            />
          )}
        />
      )}
    />
  );
};

export default WSMultiAutoComplete;
